import * as React from "react";

interface InputProps {
    editing?: boolean;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    value?: string | string[] | number;
    type?: string;
    className?: string;
    id?: string;
}

export const Input: React.FunctionComponent<InputProps> = (props: InputProps) => {
    return props.editing
        ? (
            <input
                id={props.id}
                className={props.className}
                type={props.type}
                value={props.value ? props.value : ""}
                onChange={props.onChange}
                autoFocus={true}
            />
        )
        : (
            <p id={props.id} className={props.className}>
                {props.value !== undefined && props.value !== null ? props.value : "-"}
            </p>
        );
};
